import {
    chakra,
    gatsbay,
    git, github,
    javascript,
    jquery,
    next,
    react,
    sass,
    tailwind,
    typescript, webflow
} from "../../assets/index"

export const skillsData = [
    {
        id: 1,
        name: "React Js",
        img: react
    },
    {
        id: 2,
        name: "Next Js",
        img: next
    },
    {
        id: 3,
        name: "Gatsbay Js",
        img: gatsbay
    },
    {
        id: 4,
        name: "Typescript",
        img: typescript
    },
    {
        id: 5,
        name: "Jquery",
        img: jquery
    },
    {
        id: 6,
        name: "JavaScript",
        img: javascript
    },
    {
        id: 7,
        name: "Chakra Ui",
        img: chakra
    },
    {
        id: 8,
        name: "Tailwind",
        img: tailwind
    },
    {
        id: 9,
        name: "Sass",
        img: sass
    },
    {
        id: 10,
        name: "Git",
        img: git
    },
    {
        id: 11,
        name: "GitHub",
        img: github
    },
    {
        id: 12,
        name: "Webflow",
        img: webflow
    },


]